import { US_STATES } from "@/shared/constants/constants";
import { formatPersonDateForDisplay } from "@/shared/utils/formatters";

import type { PersonContact } from "@/shared/types/estateContact";

export const YES_NO_LABELS: Record<string, string> = {
  yes: "Yes",
  no: "No",
  not_sure: "Not sure",
};

export const formatLongDate = (date: string | null | undefined): string =>
  formatPersonDateForDisplay(date, { year: "numeric", month: "long", day: "numeric" }, "");

export const formatShortDate = (date: string | null | undefined): string =>
  formatPersonDateForDisplay(date, { year: "numeric", month: "2-digit", day: "2-digit" }, "");

export const getStateName = (code: string | null | undefined): string =>
  code ? (US_STATES.find((state) => state.value === code)?.label ?? code) : "";

export const findContact = (
  contacts: PersonContact[] | undefined,
  id: number | null | undefined,
): PersonContact | undefined => (id ? contacts?.find((contact) => contact.id === id) : undefined);
